export const CIRCLE = 'CIRCLE';
export const SQUARE = 'SQUARE';
export const EDGE = 'EDGE';